<template>
    <div class="modal-goodslist">
        <div class="modal">
            <div class="modal-header">
                <div style="padding: 6px;">入住编辑</div>
                <button type="button" class="btn-close" @click="closeSelf">关闭</button>
            </div>
            <div class="modal-body">

               <el-form :model="editForm" ref="editForm">
                    <div>
                        <el-row>
                            <el-col :span="12" class="item" v-for="(value,i) in CheckinAssessGroup" :key="i">
                                <el-form-item :label="value.name">
                                    <el-select v-model="editForm.assessItemArr[i]" placeholder="请选择入住套餐" style="width:100%">
                                        <el-option
                                                v-for="item in value.checkinAssessItemList"
                                                :key="item.checkinAssessItemCode"
                                                :label="item.name"
                                                :value="item.checkinAssessItemCode">
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                            </el-col>
                        </el-row>
                    </div>

                </el-form>

            </div>
            <div class="modal-footer">
                <el-button :loading="loading" type="primary" @click="confirm('editForm')">编辑</el-button>
            </div>
        </div>
    </div>
</template>

<script>

    import {timeStr} from "@/common/times";
    import {hex_md5} from "@/common/Base64MD5";
    import {getStaffCode} from "@/utils/auth";


    export default {
        name: 'Edit',
        props:['CheckinAssessGroup'],
        data() {
            return {
                loading: false,
                editForm:{
                    timeStr:timeStr,
                    sign:'',
                    staffCode:getStaffCode(),
                    elderlyCode:'',
                    assessItemArr:[]
                },
            }
        },

        methods: {
            init(row){
                this.loading=false
                this.editForm.elderlyCode=row.elderlyCode
                this.editForm.elderlyCheckinAssessCode=row.elderlyCheckinAssessCode
                var list=row.elderlyCheckinAssessItemList
                this.editForm.assessItemArr=this.getAssessItemArr(list)
                console.log(this.editForm.assessItemArr)
            },
            getAssessItemArr(list){
                var array=[]
                for(var i in this.CheckinAssessGroup){
                    for(var j in list){
                        if(list[j].checkinAssessGroupCode==this.CheckinAssessGroup[i].checkinAssessGroupCode){
                            console.log(list[j].checkinAssessItemCode)
                            array[i]=list[j].checkinAssessItemCode
                        }
                    }
                    if(!array[i]){
                        array[i]=null
                    }
                }
                return array;
            },
            closeSelf() {
                this.$emit("closeEdit");
            },

            confirm(){
                if(this.editForm.assessItemArr.length>0){
                    this.addSubmit();
                }else{
                    this.$message({type: 'info', message: '请至少选择一项进行评估'});
                }
            },

            addSubmit(){

                if(this.loading){
                    return;
                }else{
                    this.loading = true;
                }

                 this.editForm.sign = hex_md5("timeStr=" + timeStr + "&key="+this.$signKey);
                this.editForm.assessItemArr = this.editForm.assessItemArr.filter(function (s) {
                    return s && s.trim();
                });
                this.$axios({
                    method: 'post',
                    url: this.$institutionUrl+"ElderlyCheckinAssess/Edit",
                    data: this.editForm
                }).then(
                    (response) => {
                        this.loading = false;
                        if (response.data.error == 0) {
                            this.$emit("closeEdit");
                            this.$emit("getList");
                        }else if(response.data.error == 1){
                            this.$message({type: 'info', message: response.data.message});
                        }
                    }
                )
            },


        }
    }


</script>





<style lang="scss" scoped>

    .modal-goodslist {
        position: fixed;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        background-color: rgba(0,0,0,.3);
        display: flex;
        justify-content: center;
        align-items: center;
        z-index: 99;

        .modal {
            background-color: #fff;
            box-shadow:   0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04);
            overflow-x:auto;
            display: flex;
            flex-direction: column;
            border-radius: 10px;
            width: 700px;

            .modal-header {
                border-bottom: 1px solid #eee;
                color: #313131;
                justify-content: space-between;
                padding: 10px;
                display: flex;
            }
            .modal-body {
                position: relative;
                padding: 20px 0px;
                z-index: 99;
                overflow-y: scroll;
                max-height: 450px;
            }
            .modal-footer {
                border-top: 1px solid #eee;
                justify-content: flex-end;
                padding: 15px;
                display: flex;
            }


        }

    }


    .btn-close, .btn-confirm {
        border-radius: 8px;
        margin-left:16px;
        width:56px;
        height: 36px;
        border:none;
        cursor: pointer;
    }
    .btn-close {
        color: #313131;
        background-color:transparent;
    }



    .row{
        padding: 10px 0px;
    }
    .item{
        padding: 0px 20px;
    }
    .label{
        padding: 5px 0px;
    }


</style>
